module.exports = __webpack_public_path__ + "static/img/list03.10a3a3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/list03.jpg
// module id = T60Q
// module chunks = 1